import { getErrorMessage } from "@/core/services";
import { useAsyncList } from "@/ds";
import { getEstruturaBase, getTiposObraBase } from "@/modules/financeiro-configuracoes";
import type { LinhaEstrutura, TipoObraBase } from "@/modules/financeiro-configuracoes";
import { BASE_DADOS_ERROR_MESSAGE, BASE_DADOS_FORBIDDEN_MESSAGE } from "../base-dados.constants";

const SEM_PARAMETROS = {};

export function useBaseDadosDados(incluirInativos: boolean) {
  const estrutura = useAsyncList<{ incluirInativos: boolean }, LinhaEstrutura>({
    fetcher: async (params, signal) => {
      const items = await getEstruturaBase(params, { signal });
      return { items, total: items.length };
    },
    params: { incluirInativos },
    forbiddenMessage: BASE_DADOS_FORBIDDEN_MESSAGE,
    errorMessage: BASE_DADOS_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  const tiposObra = useAsyncList<typeof SEM_PARAMETROS, TipoObraBase>({
    fetcher: async (_params, signal) => {
      const items = await getTiposObraBase({ signal });
      return { items, total: items.length };
    },
    params: SEM_PARAMETROS,
    forbiddenMessage: BASE_DADOS_FORBIDDEN_MESSAGE,
    errorMessage: BASE_DADOS_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  const resumo = (lista: typeof estrutura | typeof tiposObra) => ({
    carregando: lista.isLoading,
    pronta: lista.status === "success",
    semPermissao: lista.status === "forbidden",
    erro: lista.status === "error" ? lista.errorMessage : null,
    recarregar: lista.reload,
  });

  return {
    estrutura: { ...resumo(estrutura), itens: estrutura.items },
    tiposObra: { ...resumo(tiposObra), itens: tiposObra.items },
  };
}
